import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { lang_hr } from './translations/hr';
import { lang_en } from './translations/en';
import Vuetify from 'vuetify'

Vue.use(VueI18n);

const messages =
{
  'hr': lang_hr,
  'en': lang_en
};


export const i18n = new VueI18n({
  locale: 'hr',
  // set locale
  fallbackLocale: 'en',
  // set fallback locale
  messages,
  // set locale
  messages,
  silentTranslationWarn: true
});



Vue.use(Vuetify, {
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});



// WEBPACK FOOTER //
// ./VueSrc/Common/plugins/i18n.js